import { styled } from 'styled-components'

import { Typography } from '@b-stock/fe-core/design-system'

export const Body = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  ${Typography.Body3}
  text-align: left;
  width: 100%;
  margin: 0 auto;
  padding: 1rem 0 0;
`

export const SectionHeader = styled.p`
  ${Typography.Body2Semibold}
  margin: 0.5rem 0;
`

export const List = styled.ul`
  margin-bottom: 0.5rem;
  padding-left: 1rem;

  li {
    list-style-type: disc !important;
  }
`

export const ListItem = styled.li`
  margin-left: 1rem;
`
